export default __webpack_public_path__ + "static/media/activeHome.7f72943b.png";